import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material'

@Component({
  selector: 'cm-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css']
})
export class AlertDialogComponent implements OnInit {

  public title: string
  public message: string
  // public buttonText = 'Ok'

  constructor(private dialogRef: MdDialogRef<AlertDialogComponent>) { }

  ngOnInit() {
  }

  ok() {
    this.dialogRef.close(true)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/dialog/alert-dialog/alert-dialog.component.ts